import { Component } from '@angular/core';

@Component({
    selector: 'app-upsellrd',
    templateUrl: './upsellrd.component.html',
    styleUrls: ['./upsellrd.component.css'],
    standalone: false
})
export class UpsellrdComponent {

}
